var accordionsArray = document.getElementsByClassName("js-footer-menu-mobile");

if (accordionsArray) {
    for (var i = 0; i < accordionsArray.length; i++) {
        accordionsArray[i].addEventListener("click", function () {
            this.classList.toggle("footer__column--active");
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });
    }
}


$(document).ready(function () {
    setTimeout(function () {
     

        $(".choices.select__desktop").removeAttr("role");
        $(".choices.select__desktop").removeAttr("tabindex");
        $(".choices.select__desktop").removeAttr("aria-haspopup");
        $(".choices.select__desktop").removeAttr("aria-expanded");
       

        // $("span").removeAttr("style");

        $('a[href="https://ehplabs.com/pages/blessed-boosters#"]').each(function() {
            const $this = jQuery(this);
            if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
                $this.remove();
        });
        

    }, 3000);
    }, 3000);